module.exports = ".finance-card-container {\n  background: #e8f1f3;\n  clear: both;\n  margin: 0 -20px -20px -20px;\n  padding: 20px; }\n\ntd:not(.text-left), tfoot th {\n  white-space: nowrap; }\n\ntd.remarks {\n  white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/finance-modal/finance-modal.component.scss
// module id = ./src/app/components/finance-modal/finance-modal.component.scss
// module chunks = main